/**
 * Source of truth for "métiers" shared between the two atelier domains:
 *  - availability blocks (ZoneType, in store/disponibiliteStore.ts)
 *  - jobs/charges/workers (WorkshopSpecialty, in types/garage/atelier.ts)
 *
 * These two unions stay separate (zones also carry non-métier states like
 * pause/conge; specialty also carries "autre"), but the label + colors of the
 * *productive* métiers they share live here so the atelier filter pills and the
 * mismatch modal don't re-declare them.
 */

export interface MetierMeta {
  label: string;
  /** Accent / text color */
  color: string;
  /** Chip / card background */
  bg: string;
  /** Chip / card border */
  border: string;
}

export const METIER_META: Record<string, MetierMeta> = {
  mecanique:      { label: "Mécanique",      color: "#4F46E5", bg: "#EEF0FF", border: "#A5B4FC" },
  carrosserie:    { label: "Carrosserie",    color: "#5C6BFF", bg: "#E4E7FF", border: "#B7BDFF" },
  peinture:       { label: "Peinture",       color: "#DC2626", bg: "#FEE2E2", border: "#FECACA" },
  diagnostique:   { label: "Diagnostique",   color: "#059669", bg: "#D1FAE5", border: "#A7F3D0" },
  service_rapide: { label: "Service rapide", color: "#6F61FF", bg: "#ECE9FF", border: "#C5BFFF" },
  campagnes:      { label: "Campagnes",      color: "#EA580C", bg: "#FFEDD5", border: "#FED7AA" },
  autre:          { label: "Autre",          color: "#737373", bg: "#F5F5F5", border: "#D9D9D9" },
};

/** Ordered list of métiers shown as multi-select pills on the Planning atelier page. */
export const ATELIER_FILTER_METIERS: string[] = [
  "mecanique",
  "carrosserie",
  "peinture",
  "diagnostique",
  "service_rapide",
  "campagnes",
  "autre",
];

/** Human label for a métier key, falling back to the raw key. */
export function metierLabel(key: string | undefined): string {
  if (!key) return "";
  return METIER_META[key]?.label ?? key;
}
